import React, { Component } from 'react'
import Page from 'components/Page'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import HeadingBanner from 'components/Text/HeadingBanner'

export default class NotFound extends Component {
  render() {
    return (
      <Page
        title="Pickle - Page Not Found"
        layout={{ header: 'landing' }}
        className={sLay['layout-column']}
      >
        <div className={cn(sLay['layout-column'], sLay.flex)}>
          <HeadingBanner />
          <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sLay.flex)}>
            <div className={sText.descrip1}>What a pickle!</div>
            <div className={sText.descrip2}>This page can't be found.</div>
          </div>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/NotFound/NotFound.jsx